import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["children", "className"],
  _excluded2 = ["htmlProps", "descendants"],
  _excluded3 = ["isFitted"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { TabsDescendantsProvider, TabsProvider, useTabs } from "./chunk-ROBISDLO.mjs";

// src/tabs.tsx
import { createContext } from "@chakra-ui/react-context";
import { chakra, forwardRef, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var _createContext = createContext({
    name: "TabsStylesContext",
    errorMessage: "useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Tabs />\" "
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  TabsStylesProvider = _createContext2[0],
  useTabsStyles = _createContext2[1];
var Tabs = forwardRef(function Tabs2(props, ref) {
  var styles = useMultiStyleConfig("Tabs", props);
  var _omitThemingProps = omitThemingProps(props),
    children = _omitThemingProps.children,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var _useTabs = useTabs(rest),
    htmlProps = _useTabs.htmlProps,
    descendants = _useTabs.descendants,
    ctx = _objectWithoutProperties(_useTabs, _excluded2);
  var context = useMemo(function () {
    return ctx;
  }, [ctx]);
  var _ = htmlProps.isFitted,
    rootProps = _objectWithoutProperties(htmlProps, _excluded3);
  return /* @__PURE__ */jsx(TabsDescendantsProvider, {
    value: descendants,
    children: /* @__PURE__ */jsx(TabsProvider, {
      value: context,
      children: /* @__PURE__ */jsx(TabsStylesProvider, {
        value: styles,
        children: /* @__PURE__ */jsx(chakra.div, _objectSpread(_objectSpread({
          className: cx("chakra-tabs", className),
          ref: ref
        }, rootProps), {}, {
          __css: styles.root,
          children: children
        }))
      })
    })
  });
});
Tabs.displayName = "Tabs";
export { useTabsStyles, Tabs };